import progressBarDo from "../../../../../../packages/design-system/progress-bar/constellation/index/images/progress-bar-loading-do.png";
import progressBarDont from "../../../../../../packages/design-system/progress-bar/constellation/index/images/progress-bar-data-viz-dont.png";
import * as React from 'react';
export default {
  progressBarDo,
  progressBarDont,
  React
};